import { actionTypeKeys } from "../actions/actionTypeKeys";
import { AnyAction } from "redux";
import { initialState } from "../store/initialState";
import { DeepLinkStatus } from "../types/deepLink";

export default function deepLinkReducer(state: DeepLinkStatus = initialState.deepLinkStatus, action: AnyAction) {
  switch (action.type) {
    case actionTypeKeys.UPDATE_DEEP_LINK_STATUS:
      return { ...action.payload };
    default:
      return state;
  }
}
